import styled from 'styled-components'
import Typography, { FontWeights } from 'builder/styles/typography'
import Colors from 'builder/styles/colors'
import Media from 'builder/styles/media'
import Button from 'builder/components/Button'
import Sizes from 'builder/styles/sizes'
import { fadeIn } from 'builder/styles/keyframes'

export const Screen = styled.div`
  display: flex;
  gap: 20px;
  margin: auto;

  ${Media.Tablet`
    flex-direction: column;
  `};

  ${Media.Phone`
    padding-left: 18px;
    padding-right: 10px;
  `};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.White};

  ${Media.Tablet`
    width: 100%;
    order: 2;
  `};
`

export const TextContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  &.support {
    margin-top: 8px;

    ${Media.Tablet`
      padding-left: 75px;
    `};

    ${Media.Phone`
      padding-left: 0;
    `};
  }

  &.title {
    ${Media.Phone`
      margin-bottom: 8px;
    `};
  }
`

export const Title = styled.p`
  ${Typography.L};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};

  &.amount {
    color: ${Colors.Blue50};
  }
`

export const Content = styled.div`
  display: flex;
  gap: 65px;
  margin-top: 12px;

  ${Media.Tablet`
    flex-direction: column;
    gap: 36px;
    width: 100%;
  `};

  ${Media.Phone`
    gap: 28px;
  `};
`

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;

  ${Media.Tablet`
    max-width: unset;
    padding: 0 32px;
  `};

  ${Media.Phone`
    padding: 0;
  `};
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;

  ${Media.Phone`
    margin-top: 16px;
    gap: 16px;
  `};
`

export const ItemContainer = styled.div`
  display: flex;
  gap: 8px;

  ${Media.Tablet`
    align-items: flex-start;
  `};

  ${Media.Phone`
    align-items: center;
  `};
`

export const Item = styled.p`
  ${Typography.Body};
  color: ${Colors.Neutral80};

  &.bold {
    ${FontWeights.Medium};
  }

  ${Media.Phone`
    font-size: 15px;
  `};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Sizes.S};
  align-self: flex-start;
  align-items: center;
  margin-top: 32px;

  ${Media.Tablet`
    margin-top: 28px;
    width: 100%;
    padding-right: 42px;
  `};

  ${Media.Phone`
    margin-top: 12px;
  `};
`

export const PremiumButton = styled(Button)`
  width: 351px;

  ${Media.Tablet`
    flex: 1;
  `};

  ${Media.Phone`
    width: 100%;
  `};
`

export const SkipButton = styled(Button)`
  width: 144px;
`

export const Header = styled.span`
  color: ${Colors.Neutral50};
  ${Typography.Caps};

  ${Media.Tablet`
    margin-left: 32px;
  `};

  ${Media.Phone`
    margin-left: 0;
  `};
`

export const Icon = styled.img`
  width: 24px;
  height: 24px;

  ${Media.Phone`
    width: 20px;
    height: 20px;
  `};
`

export const CancelAnytime = styled.span`
  margin-top: 8px;
`

export const Subtitle = styled.span`
  ${Typography.Caption};
  ${FontWeights.Medium};
  color: ${Colors.Neutral50};
  margin-top: 16px;

  ${Media.Phone`
    display: none;
  `};

  &.mobile {
    display: none;
    margin-top: 0;

    ${Media.Phone`
      display: flex;
    `};
  }
`

export const SliderContent = styled.div`
  width: 100%;
  animation: ${fadeIn} 0.3s ease;
  animation-fill-mode: forwards;
  position: relative;

  & .swiper-container {
    position: relative;
    overflow: visible;

    ${Media.Tablet`
      overflow: hidden;
    `}
  }

  & .swiper-wrapper {
    display: flex;
    position: relative;
    transition-property: transform;
  }

  .swiper-slide-active,
  .swiper-slide-next,
  .swiper-slide-prev {
    opacity: 1;
  }
`

export const SliderContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 480px;
  height: 531px;
  border-radius: 16px;

  ${Media.Tablet`
    width: 695px;
    height: 476px;
  `};

  ${Media.Phone`
    width: 339px;
    height: 232px;
    margin: auto;
  `};
`

export const CustomPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 32px;
  left: 32px;
  z-index: 99999999;

  ${Media.Phone`
    top: 12px;
    left: 16px;
  `};

  .box {
    width: 56px;
    height: 4px;
    background-color: ${Colors.Blue30};
    border-radius: 16px;

    ${Media.Tablet`
      width: 87px;
    `};

    ${Media.Phone`
      width: 41px;
    `};
  }
`

export const AnimationImage = styled.img`
  width: 480px;
  height: 531px;
  border-radius: 16px;

  ${Media.Tablet`
    width: 695px;
    height: 476px;
  `};

  ${Media.Phone`
    width: 339px;
    height: 232px;
  `};
`

export const Support = styled.p`
  ${Typography.Caption};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};

  &.email {
    color: ${Colors.Blue50};
  }
`
